import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';
import '../styles/components/HamburgerMenu.css';

/**
 * HamburgerMenu - 共通スライドパネルメニュー
 *
 * @param {boolean} isOpen - 開閉状態
 * @param {function} onClose - 閉じるコールバック
 * @param {Array<{icon: string, label: string, onClick: function}>} menuItems - メニュー項目
 * @param {number[]} showDividerAfter - 仕切り線を入れるindex配列
 */
const HamburgerMenu = ({ isOpen, onClose, menuItems = [], showDividerAfter = [] }) => {
  useEffect(() => {
    if (!isOpen) return;
    const handleKeyDown = (e) => {
      if (e.key === 'Escape') onClose();
    };
    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return ReactDOM.createPortal(
    <div className="hamburger-menu-overlay" onClick={onClose}>
      <div className="hamburger-menu-panel" onClick={(e) => e.stopPropagation()}>
        <div className="hamburger-menu-header">
          <img src="/tsumugi2.png" alt="つむぎ" />
          <span className="menu-title">メニュー</span>
        </div>
        <div className="hamburger-menu-items">
          {menuItems.map((item, index) => (
            <React.Fragment key={index}>
              <button className="hamburger-menu-item" onClick={item.onClick}>
                <i className={item.icon}></i>
                <span>{item.label}</span>
              </button>
              {showDividerAfter.includes(index) && (
                <div className="hamburger-menu-divider"></div>
              )}
            </React.Fragment>
          ))}
        </div>
        <button className="hamburger-menu-close" onClick={onClose}>
          閉じる
        </button>
      </div>
    </div>,
    document.body
  );
};

export default HamburgerMenu;
